import {h} from 'ui/Framework';

export default h('svg', {
  width: '30',
  height: '30',
  viewBox: '-1 -1 32 32',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('rect', {
          stroke: '#21304A',
          fill: 'none',
          width: '30',
          height: '30',
          rx: '5'
        }),
        h('path', {
          d: 'M5.75 23.571h15c.414 0 .75-.4.75-.898 0-.495-.336-.897-.75-.897h-15c-.414 0-.75.402-.75.897 0 .497.336.898.75.898zm0-9.775h19.5c.414 0 .75-.401.75-.898 0-.496-.336-.898-.75-.898H5.75c-.414 0-.75.402-.75.898 0 .497.336.898.75.898zm0 5h19.5c.414 0 .75-.401.75-.898 0-.496-.336-.898-.75-.898H5.75c-.414 0-.75.402-.75.898 0 .497.336.898.75.898zm0-10h19.5c.414 0 .75-.401.75-.898 0-.496-.336-.898-.75-.898H5.75c-.414 0-.75.402-.75.898 0 .497.336.898.75.898z',
          fill: '#000'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-longtext-small.es6.js